import { trackDiffPricingShow, trackServicesShow, trackSliderScroll } from '../v1/tracking';
import { useServicesAnalyticsParams } from './useServicesAnalyticsParams';
import { useSelector } from 'react-redux';
import { selectExperiments } from '../../../../../../../selectors/experiments';
import { trackChangeService } from '../tracking';
import { servicesCardsTextsExperimentName } from '../../../../../../../constants/experiments';

type TSliderScrollDirections = 'right' | 'left';

interface IUseServicesAnalyticsHandlers {
  onServicesShow: () => void;
  onDiffPricingShow: () => void;
  onServiceChange: () => void;
  onSliderScroll: (direction: TSliderScrollDirections) => void;
}

export const useServicesAnalyticsHandlers = (): IUseServicesAnalyticsHandlers => {
  const experiments = useSelector(selectExperiments);
  const analyticsParams = useServicesAnalyticsParams();

  const onServicesShow = () => {
    trackServicesShow({ ...analyticsParams, testGroupName: experiments[servicesCardsTextsExperimentName]! });
  };

  const onDiffPricingShow = () => {
    if (analyticsParams.diffPricingIds) {
      const { diffPriceIterationId, diffPriceGranuleGuid } = analyticsParams.diffPricingIds;

      trackDiffPricingShow({
        analyticsOfferStatus: analyticsParams.analyticsOfferStatus,
        analyticsFormId: analyticsParams.analyticsFormId,
        diffPriceIterationId,
        diffPriceGranuleGuid,
      });
    }
  };

  const onSliderScroll = (direction: TSliderScrollDirections) => {
    trackSliderScroll({ ...analyticsParams, direction });
  };

  const onServiceChange = () => {
    trackChangeService(analyticsParams);
  };

  return {
    onServicesShow,
    onDiffPricingShow,
    onSliderScroll,
    onServiceChange,
  };
};
